import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { StripeService } from "../../services/stripe.service";
import { CheckboxCard } from "../../../forms/forms";
import { AuthenticationService } from "../../../core/core";
import { PaymentElementComponent } from "../payment-element/payment-element.component";

@Component({
  selector: "common-select-payment-methods",
  templateUrl: "./select-payment-methods.component.html",
  styleUrls: ["./select-payment-methods.component.scss"],
})
export class SelectPaymentMethodsComponent implements OnInit {
  @Input() showCreateButton: boolean = false;
  @Input() paymentCompletionPage: string;
  @Output() paymentMethodIdChange = new EventEmitter<string>();

  errorMessage: string;
  paymentMethodCards: any;
  user: any;
  newPaymentMethod: boolean;

  @ViewChild(PaymentElementComponent) paymentElementComponent: PaymentElementComponent;

  constructor(private stripeService: StripeService, private authenticationService: AuthenticationService) {
    this.user = this.authenticationService.getUserNonAsync();
  }

  ngOnInit(): void {
    if (!this.user?.profile?.account_id) {
      console.error("No account ID available for loading payment methods");
      this.errorMessage = "Unable to load payment methods. Please try refreshing the page.";
      return;
    }

    this.stripeService.paymentMethods(this.user.profile.account_id).subscribe({
      next: (response: any) => {
        this.paymentMethodCards = response?.data?.map((paymentMethod: any) => {
          let label = "";
          let rightLabel = "";

          if (paymentMethod.card) {
            // Card payment method
            label = `${paymentMethod.card.display_brand.toUpperCase()} **** **** **** ${paymentMethod.card.last4}`;
            rightLabel = `Exp: ${paymentMethod.card.exp_month}/${paymentMethod.card.exp_year}`;
          } else if (paymentMethod.us_bank_account) {
            // Bank account payment method
            label = `${paymentMethod.us_bank_account.bank_name} **** ${paymentMethod.us_bank_account.last4}`;
            rightLabel = paymentMethod.us_bank_account.account_type?.charAt(0).toUpperCase() + paymentMethod.us_bank_account.account_type?.slice(1) || "";
          } else {
            // Fallback for other payment method types
            label = `Payment Method ${paymentMethod.type || ""}`;
            rightLabel = "";
          }

          return {
            value: paymentMethod.id,
            label: label,
            rightLabel: rightLabel,
            checked: false,
          } as CheckboxCard;
        });

        if (this.paymentMethodCards?.length > 0) {
          const addNewPayment = {
            value: "new",
            label: `Add new payment method`,
            checked: false,
          } as CheckboxCard;
          this.paymentMethodCards.push(addNewPayment);
          return;
        }

        this.newPaymentMethod = true;
        this.paymentMethodIdChange.emit("new");
      },
      error: error => {
        console.error("Debug: Error loading payment methods", error);
        this.errorMessage = "Failed to load payment methods. Please try again.";
        // Still show the "add new payment method" option
        this.newPaymentMethod = true;
        this.paymentMethodIdChange.emit("new");
      },
    });
  }

  paymentMethodOnChange(checkboxCards: CheckboxCard[]) {
    const checked = checkboxCards.find(d => d.checked == true);

    if (!checked) {
      return;
    }

    if (checked.value == "new") {
      this.newPaymentMethod = true;
      this.paymentMethodIdChange.emit("new");
      return;
    }

    this.newPaymentMethod = false;
    this.paymentMethodIdChange.emit(checked.value);
  }

  submit(paymentCompletionPage: string) {
    this.paymentCompletionPage = paymentCompletionPage;
    this.paymentElementComponent.submit(null, paymentCompletionPage);
  }
}
